import stringify from 'qs-stringify'
import md5 from 'md5'
import { getUrlParam } from './util'
import { getCookie } from '~/plugins/xl-cookie'
import { GameFlag, statData } from '~/constant'
export { allResolve, asyncErrorCaptured } from './util'

export function isDef(val) {
  return val !== undefined && val !== null
}
export function isNotDef(val) {
  return val === undefined || val === null
}

export function bannerJump({ collection_type, game_id, server_id, jump_url }) {
  if (collection_type === Global.CONS.CollectionType.act) {
    window.open(jump_url)
  } else if (server_id) {
    playGame({ game_id, server_id })
  } else {
    $nuxt.$router.push(`/game-offical/${game_id}`)
  }
}

export function jumpUrl(url) {
  // 判断如果是游戏链接则使用公共游戏方法打开
  const reg = /game-offical+\/+\d+\/play/i
  if (reg.test(url)) {
    const game_id = url.match(reg)[0].match(/\d+/)[0]
    const server_id = getUrlParam('server_id', url)
    playGame({ game_id, server_id })
  } else {
    window.open(url)
  }
}

export function gamePage({ game_id }) {
  window.open(`https://wan.xunlei.com/game-offical/${game_id}/`)
}

export function playGame({ game_id, server_id = 0 }) {
  gameStat(game_id, server_id, '', '')
  // window.open(
  //   `http://wan.xunlei.com/game-offical/${game_id}/play?server_id=${server_id}`
  // )
}

export function goRecharge(queries = {}) {
  window.open(`https://wan.xunlei.com/recharge?${stringify(queries)}`)
}

export function goGiftDetail({ id, quantity, granted, title }, check = false) {
  if (check && quantity <= granted) {
    return $nuxt.$notify('该礼包已领完~')
  }
  $nuxt.$router.push(`/gifts/${id}?title=${title}`)
}

export function goGiftDetailPlaySideBar(
  { id, quantity, granted },
  check = false
) {
  if (check && quantity <= granted) {
    return $nuxt.$notify('该礼包已领完~')
  }
  window.open(`http://wan.xunlei.com/gifts/${id}`)
}

export function flagName(flag) {
  return GameFlag[flag]
}

export function getGameById(game_id) {
  const { serverList } = $nuxt.$store.state.app
  return serverList.filter((e) => e.game_id === game_id)[0] || {}
}

export function getServerById(game_id, server_id) {
  const list = getGameById(game_id).server_list || []
  return list.filter((e) => e.server_id === server_id)[0] || {}
}

export function gameInitStat(gameid) {
  const { pro: defaultPro } = statData
  // 嵌套的情况下埋点信息需获取iframe父层url参数,非嵌套(windo.parent=window)获取当前url参数
  let url = ''
  try {
    url = window.parent.location.href
  } catch (error) {
    url = window.location.href
  }
  let pro = getUrlParam('pro', url)
  let referrer = getUrlParam('referrer', url)
  let referrer_desc = getUrlParam('referrer_desc', url)
  if (window.parent !== window && !pro && !referrer && !referrer_desc) {
    // 如果父层没带埋点信息, 则尝试获取当前url
    pro = getUrlParam('pro')
    referrer = getUrlParam('referrer')
    referrer_desc = getUrlParam('referrer_desc')
  }
  if (!pro) {
    pro = defaultPro
  }
  // 检测pro规范
  const proRex = /^xl_/
  const isXLPro = proRex.test(pro)
  if (pro && !isXLPro) {
    pro = `xl_${pro}`
  }
  const server_id = getUrlParam('server_id')
  const options = {
    pro,
    gameid,
    game_sid: server_id,
    eid: referrer,
    eid_desc: referrer_desc,
    dty: 'gas',
    ive: 'xunlei-ver-1.0.0'
  }
  const initStatOptions = {
    loginout: false,
    startup: true,
    endup: true
  }
  this.yaStat =
    this.yaStat instanceof window.YA2
      ? this.yaStat
      : new window.YA2(options, { initStatOptions })
}

export function loginStat(eid, eid_desc) {
  const { pro, channel, channel_desc } = statData
  window.f2eGame &&
    window.f2eGame.port.statpid.loginStat({
      pro,
      eid: `login/${channel}/${eid}`,
      eid_desc: `登录/${channel_desc}/${eid_desc}`
    })
}

export function clickStat(eid, eid_desc, isCover = false) {
  const { channel, channel_desc } = statData
  window.f2eGame &&
    window.f2eGame.port.statpid.clickStat({
      eid: isCover ? eid : `click/${channel}/${eid}`,
      eid_desc: isCover ? eid_desc : `点击/${channel_desc}/${eid_desc}`
    })
}

export function f2eGameStat(params) {
  const referfrom = getUrlParam('referfrom') || getCookie('xwgame_referfrom')
  if (referfrom && referfrom !== 'undefined') {
    params.ext = `referfrom=${referfrom}`
  }
  const actfrom = getUrlParam('actfrom') || getCookie('xwgame_actfrom')
  if (actfrom && actfrom !== 'undefined') {
    params.ext = `actfrom=${actfrom}`
  }
  window.f2eGame && window.f2eGame.port.statpid.gameStat(params)
  // 雷方要求数据上报
  if (window !== window.top) {
    return
  }
  if (!getCookie('userid')) {
    return
  }
  const gameId = params.gameId || ''
  const serverId = params.serverId || ''
  const body = {
    reportType: 2,
    runtime: 1,
    startGamePayload: {
      gameId: gameId.toString(),
      gameType: 1,
      serverId: serverId.toString()
    },
    platform: 'gamebox',
    userId: getCookie('userid')
  }
  window.$.ajax({
    url: '//youxi.xunlei.com/api/gamebox/v1/data/report',
    type: 'post',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(body),
    xhrFields: {
      withCredentials: true
    }
  })
}

export function gameStat(gameId, serverId, eid, eid_desc, server_code = 0) {
  const { channel, channel_desc } = statData
  clickStat(eid, eid_desc)
  f2eGameStat({
    gameId,
    serverId,
    server_code,
    eid: `click/${channel}/${eid}`,
    eid_desc: `点击/${channel_desc}/${eid_desc}`
  })
}

export async function f2eAjax($ajaxData, options) {
  $ajaxData = $ajaxData && typeof $ajaxData === 'object' ? $ajaxData : {}
  $ajaxData.data = $ajaxData.data || {}
  $ajaxData.dataType =
    $ajaxData.dataType && typeof $ajaxData.dataType === 'string'
      ? $ajaxData.dataType
      : 'jsonp'
  options = options && typeof options === 'object' ? options : {}
  options.isAutoAddUserData =
    typeof options.isAutoAddUserData === 'boolean'
      ? options.isAutoAddUserData
      : true
  options.keySessionId =
    options.keySessionId && typeof options.keySessionId === 'string'
      ? options.keySessionId
      : 'sessionid'
  options.keyUserId =
    options.keyUserId && typeof options.keyUserId === 'string'
      ? options.keyUserId
      : 'userid'
  if (options.isAutoAddUserData && typeof $ajaxData.data === 'object') {
    $ajaxData.data[options.keySessionId] = getCookie('sessionid')
    $ajaxData.data[options.keyUserId] = getCookie('userid')
  }
  if (window.f2eGame) {
    return await window.f2eGame.util.loadData($ajaxData)
  } else {
    return Promise.resolve()
  }
}

// 排序方法
export function arraySort(array, key, sortBy = 'asc') {
  return array.sort((a, b) => {
    const x = a[key]
    const y = b[key]
    return sortBy === 'asc' ? x - y : y - x
  })
}

// 根据状态显示是否可充值
export function getPayStatus(status) {
  return status === 1 || status === 4
}

// 签名
export function genSign(data = {}, keyValue) {
  const key = keyValue
  let name
  let str = ''
  let i = 0
  const arr = []
  for (name in data) {
    if (Object.prototype.hasOwnProperty.call(data, name)) {
      arr.push(name)
    }
  }
  const len = arr.length
  if (len > 0) {
    arr.sort()
    for (; i < len; i++) {
      if (!['', undefined].includes(data[arr[i]])) {
        str += arr[i] + '=' + data[arr[i]] + '&'
      }
    }
  }
  const sign = md5(str.substring(0, str.length - 1) + '&key=' + key)
  return sign
}

export function realNameAuth(
  scene = '',
  gameId = '',
  succfn = function() {},
  failfn = function() {}
) {
  const realNameAuth = new window.f2eGame.ui.RealNameAuth2({
    gameId,
    scene,
    succfn,
    failfn
  })
  console.log(realNameAuth)
}

function isInThunderPC() {
  return /\s+Thunder/.test(window.navigator.userAgent)
}

function isInThunderBOX() {
  return /\s+XLGame/.test(window.navigator.userAgent)
}

function isInThunderAndroid() {
  return /\s+iThunder;thirdChannel_SHOUJIXUNLEI/.test(
    window.navigator.userAgent
  )
}

function isInEXEClient() {
  return /Chrome\/67.0.3396.79/.test(window.navigator.userAgent)
}

// 获取runtime
export function getRunTime() {
  let flag = 'Unknown'
  // 客户端类型clientType web:浏览器 app:微端 box:盒子 h5:H5 UnknownUA:未知 Browser:浏览器 XLGame:迅雷游戏盒子 Andorid:安卓 IOS:IOS EXEClient:端游 PCXunLei:PC迅雷 Wechat:微信
  const clientType = getUrlParam('run_time')
  if (clientType) {
    switch (clientType) {
      case 'web':
        flag = 'Browser'
        break
      case 'app':
        flag = 'EXEClient'
        break
      case 'box':
        flag = 'XLGame'
        break
      default:
        flag = clientType
        break
    }
    return flag
  }
  // url没有传clientType, 则判断系统环境
  if (isInThunderPC()) {
    flag = 'PCXunLei'
  } else if (isInThunderBOX()) {
    flag = 'XLGame'
  } else if (isInThunderAndroid()) {
    flag = 'Andorid'
  } else if (isInEXEClient()) {
    flag = 'EXEClient'
  } else {
    flag = 'Browser'
  }
  return flag
}

// 获取runtime
export function getClientType() {
  let flag = 'web'
  // 客户端类型clientType web:浏览器 app:微端 box:盒子 h5:H5
  if (isInThunderBOX()) {
    flag = 'box'
  }
  return flag
}

/**
 * 格式化日期
 */
export function toDateString(oDate, mapperStr) {
  if (!oDate) return ''
  if (!mapperStr) return oDate.toString()

  const Y = oDate.getFullYear()
  const M = oDate.getMonth() + 1
  const D = oDate.getDate()
  const h = oDate.getHours()
  const m = oDate.getMinutes()
  const s = oDate.getSeconds()
  const ms = oDate.getMilliseconds()

  if (/YY/g.test(mapperStr)) {
    mapperStr = mapperStr.replace(/YY/g, `${Y}`)
  } else if (/Y/g.test(mapperStr)) {
    mapperStr = mapperStr.replace(/Y/g, `${Y}`.slice(-2))
  }

  if (/MM/g.test(mapperStr)) {
    const sM = M > 9 ? `${M}` : `0${M}`
    mapperStr = mapperStr.replace(/MM/g, `${sM}`)
  } else if (/M/g.test(mapperStr)) {
    mapperStr = mapperStr.replace(/M/g, `${M}`)
  }

  if (/DD/g.test(mapperStr)) {
    const sD = D > 9 ? `${D}` : `0${D}`
    mapperStr = mapperStr.replace(/DD/g, `${sD}`)
  } else if (/D/g.test(mapperStr)) {
    mapperStr = mapperStr.replace(/D/g, `${D}`)
  }

  if (/hh/g.test(mapperStr)) {
    const sh = h > 9 ? `${h}` : `0${h}`
    mapperStr = mapperStr.replace(/hh/g, `${sh}`)
  } else if (/h/g.test(mapperStr)) {
    mapperStr = mapperStr.replace(/h/g, `${h}`)
  }

  if (/mm/g.test(mapperStr)) {
    const sm = m > 9 ? `${m}` : `0${m}`
    mapperStr = mapperStr.replace(/mm/g, `${sm}`)
  } else if (/m/g.test(mapperStr)) {
    mapperStr = mapperStr.replace(/m/g, `${m}`)
  }

  if (/ss/g.test(mapperStr)) {
    const ss = s > 9 ? `${s}` : `0${s}`
    mapperStr = mapperStr.replace(/ss/g, `${ss}`)
  } else if (/s/g.test(mapperStr)) {
    mapperStr = mapperStr.replace(/s/g, `${s}`)
  }

  mapperStr = mapperStr.replace(/x/g, `${ms}`)

  return mapperStr
}
